<template>
  <vs-card>
    <div slot="header">Circulo de credito</div>

    <business-profile-cdc-module
      v-if="!isPhysical(this.project.client.user.person_type)" />

    <personal-profile-cdc-module
      v-else
      :person="this.project.client.fiscal"
      :project-id="project.id" />

  </vs-card>
</template>

<script>
import BusinessProfileCdcModule from "@views/admin/Score/BusinessProfileCdcModule";
import {mapState} from "vuex";
import PersonalProfileCdcModule from "@views/admin/Score/PersonalProfileCdcModule";

export default {
  name: "circulo-credito-score-dashboard",
  components: {PersonalProfileCdcModule, BusinessProfileCdcModule},
  computed: {
    ...mapState("projects", ["project"])
  },
  methods: {
    isPhysical(personType) {
      return personType === 1 || personType === 2;
    }
  }
}
</script>

<style scoped>

</style>
